export default __webpack_public_path__ + "static/media/book_int_record.4b042571.mp3";